import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram, 
} from '..';
import css from './SocialShare.module.css';
import IconWebsite from '../IconWebsite/IconWebsite';

// Inline SVG icons for additional networks
const IconLinkedIn = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8.98h5V24H0V8.98zM8.98 8.98H14v2.05h.08c.7-1.32 2.42-2.71 4.98-2.71 5.32 0 6.3 3.5 6.3 8.04V24h-5v-6.9c0-1.64-.03-3.76-2.3-3.76-2.3 0-2.65 1.8-2.65 3.64V24h-5V8.98z"
      fill="currentColor"
    />
  </svg>
);

const IconPinterest = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 0C5.37 0 0 5.37 0 12c0 4.99 3.06 9.24 7.39 10.99-.1-.94-.2-2.39.04-3.42.22-.94 1.45-6 1.45-6s-.37-.75-.37-1.86c0-1.75 1.02-3.05 2.28-3.05 1.08 0 1.6.81 1.6 1.79 0 1.09-.7 2.72-1.06 4.23-.3 1.25.63 2.27 1.86 2.27 2.24 0 3.96-2.36 3.96-5.77 0-3.02-2.17-5.14-5.27-5.14-3.59 0-5.7 2.69-5.7 5.48 0 1.09.42 2.26.95 2.9.1.12.11.22.08.34-.09.37-.3 1.18-.34 1.35-.05.22-.18.3-.41.18-1.53-.71-2.49-2.94-2.49-4.73 0-3.86 2.81-7.4 8.1-7.4 4.25 0 7.56 3.03 7.56 7.08 0 4.23-2.66 7.63-6.37 7.63-1.25 0-2.44-.65-2.84-1.41l-.77 2.93c-.28 1.07-1.04 2.4-1.55 3.21 1.17.36 2.4.55 3.68.55 6.63 0 12-5.37 12-12S18.63 0 12 0z"
      fill="currentColor"
    />
  </svg>
);

const IconTikTok = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 8.5c-2.2 0-4.2-1-5.5-2.6V16c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6c.34 0 .67.03 1 .1v3.2c-.32-.1-.66-.16-1-.16-1.66 0-3 1.35-3 3.02 0 1.66 1.34 3.02 3 3.02s3-1.36 3-3.02V1h3c.3 2.2 2 4 4.2 4.6V8.5z"
      fill="currentColor"
    />
  </svg>
);

const IconX = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.36 1H21l-6.5 7.43L22 23h-6.78l-5.3-7.72L3.8 23H1l7.03-8.04L2 1h6.86l4.78 6.9L18.36 1zm-1.18 20h1.86L7.03 3H5.2l12-2e-3L9.68 9.57 17.18 21z"
      fill="currentColor"
    />
  </svg>
);

const SocialShare = ({
  facebookUrl = '',
  instagramUrl = '',
  linkedinUrl = '',
  tiktokUrl = '',
  xUrl = '',
  pinterestUrl = '',
  websiteUrl = '',
  className,
}) => {
  const rootClasses = classNames(css.root, className);

  const items = [
    { name: 'Facebook', url: facebookUrl, icon: <IconSocialMediaFacebook /> },
    { name: 'Instagram', url: instagramUrl, icon: <IconSocialMediaInstagram /> },
    { name: 'X', url: xUrl, icon: <IconX /> },
    { name: 'LinkedIn', url: linkedinUrl, icon: <IconLinkedIn /> },
    { name: 'TikTok', url: tiktokUrl, icon: <IconTikTok /> },
    { name: 'Pinterest', url: pinterestUrl, icon: <IconPinterest /> },
    { name: 'Website', url: websiteUrl, icon: <IconWebsite /> },
  ].filter(item => Boolean(item.url)); // remove empty URLs

  if (items.length === 0) return null;
const normalizeUrl = url => {
  if (!url) return '';
  return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
};
  return (
    <div className={rootClasses}>
      {items.map(item => (
        <a
          key={item.name}
           href={normalizeUrl(item.url)}
          target="_blank"
          rel="noopener noreferrer"
          className={css.iconButton}
          aria-label={`Visit ${item.name}`}
        >
          {item.icon}
          <span className={css.label}>{item.name}</span>
        </a>
      ))}
    </div>
  );
};

SocialShare.propTypes = {
  facebookUrl: PropTypes.string,
  instagramUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  tiktokUrl: PropTypes.string,
  xUrl: PropTypes.string,
  pinterestUrl: PropTypes.string,
  websiteUrl: PropTypes.string,
  className: PropTypes.string,
};

export default SocialShare;
